function hideAllProducts() {
    let tousLesProduits = document.querySelectorAll('.product');
    tousLesProduits.forEach(function (produit) {
      produit.style.display = 'none';
    });
  }

    // Fonction pour mettre à jour le récapitulatif des inputs choisis
    function updateRecapitulatif() {
      let listeUnputsChoisis = document.getElementById("listeInputsChoisis");
      listeUnputsChoisis.innerHTML = ""; // Efface le contenu actuel du récapitulatif

      // Sélectionne tous les inputs :checked et ajoute-les au récapitulatif
      let inputsChecked = document.querySelectorAll("input:checked");
      inputsChecked.forEach(function(input) {
          let nouvelElement = document.createElement("li");
          nouvelElement.textContent = input.id;
          listeInputsChoisis.appendChild(nouvelElement);
      });
  }

 // Ajoutez des écouteurs d'événements à tous les inputs
 document.querySelectorAll("input[type=radio], input[type=checkbox]").forEach(function(input) {
      input.addEventListener("change", function() {
          updateRecapitulatif();
      });
  });


 // Récupération des étapes et de la barre de progression
const steps = document.querySelectorAll('.step');
const progressBar = document.getElementById('progressBar');

// Fonction pour mettre en surbrillance l'étape active
function highlightStep(stepId) {
    steps.forEach(step => {
        if (step.id === stepId) {
            step.classList.add('active');
        } else {
            step.classList.remove('active');
        }
    });
}

// Écouteurs d'événements pour chaque étape
steps.forEach(step => {
    step.addEventListener('click', () => {
        const stepId = step.id;
        highlightStep(stepId);
    });
});

// Fonction d'initialisation
function init() {
    // Définition de la position verticale des étapes sur la barre de progression
    const progressBarHeight = progressBar.clientHeight;
    steps.forEach((step, index) => {
        step.style.top = `${(index / (steps.length - 1)) * (progressBarHeight - 10)}px`;
    });
}

// Appel de la fonction d'initialisation
init();

// Fonction pour revenir à la section "moments" depuis la section "besoins"
//function retournerAMoments() {
   // document.getElementById('besoins').style.display = 'none';
   // document.getElementById('moments').style.display = 'block';
  //} 

  document.getElementById('valider3').addEventListener('click', function() {
    // Récupérer toutes les données des inputs sélectionnés
    let data = {
        sexe: document.querySelector('input[name="sexe"]:checked').value,
        age: document.querySelector('input[name="age"]:checked').value,
        agenda: document.querySelector('input[name="agenda"]:checked').value,
        regimeAlimentaire: [],
        envies1: [],
        besoins: []
    };

    document.querySelectorAll('input[name="regimeAlimentaire"]:checked').forEach(input => {
        data.regimeAlimentaire.push(input.value);
    });

    document.querySelectorAll('input[name="envies1"]:checked').forEach(input => {
        data.envies1.push(input.value);
    });

    document.querySelectorAll('input[name="besoins"]:checked').forEach(input => {
        data.besoins.push(input.value);
    });

    // Convertir les données en chaîne JSON
    let jsonData = JSON.stringify(data);

    // Enregistrer les données dans un fichier texte
    let filename = 'userData.json'; // Nom du fichier
    let blob = new Blob([jsonData], { type: 'text/plain' });

    // Créer un lien pour télécharger le fichier
    let link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = filename;

    // Simuler un clic sur le lien pour télécharger le fichier
    link.click();
});

// Sélectionne les éléments
const popup = document.getElementById('popup');
const closePopupBtn = document.getElementById('close-popup');

// Ajoute un événement pour fermer le pop-up
closePopupBtn.addEventListener('click', () => {
  popup.style.display = 'none';
});